import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { AuthProvider } from "./components/auth/AuthContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ResetPassword from "./pages/auth/ResetPassword"; // Asegúrate de que la ruta sea correcta

import AcceptCookies from "./components/auth/acceptcookies";

import Navbar from "./components/Navbar";
import Inicio from "./pages/inicio";
// Páginas de administración
import Administracion from "./pages/admin/administracion";
import Administradores from "./pages/admin/administradores";
import Imagenes from "./pages/admin/imagenes";
import ContactoAdm from "./pages/admin/contacto";
import Tablas from "./pages/admin/tablas";
import Usuarios from "./pages/admin/usuarios";
import ObrasAdmin from "./pages/admin/obras";
import ObrasHelp from "./pages/admin/obrashelp";
import MuestrasAdmin from "./pages/admin/muestras";
import MuestraImagenes from "./pages/admin/muestraimagenes";
import Contacto from "./pages/users/contacto";
import Pedidos from "./pages/admin/pedidos";
import CotizacionesAdmin from "./pages/admin/cotizacionadmin";
import Muestras from "./pages/users/muestras";
import Estadistica from "./pages/admin/estadistica";

// Página de usuario - Mis Pedidos
import Carrito from "./pages/users/carrito";
import CarritoMB from "./pages/users/carritomobile";
import Obras from "./pages/users/obras";
import Obrasdet from "./pages/users/obrasdet";
import Mispedidos from "./pages/users/mispedidos";
import Cotizacion from "./pages/users/cotizacion";

// Paginas del resultado de Mercado Pagos
import Success from "./pages/mercadopago/success";
import Failure from "./pages/mercadopago/failure";
import Pending from "./pages/mercadopago/pending";
import { registerVisit } from "./utils/analytics";

function RouteVisitTracker() {
   useEffect(() => {
      registerVisit({ pathname: window.location.pathname });
   }, []);

   return null;
}


function App() {
   return (
      <AuthProvider>
         <Router>
            <RouteVisitTracker />
               <div className="min-h-screen flex flex-col">
                      <Navbar />
                  <main className="flex-grow">
                     <Routes>
                        {/* Public routes */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route
                           path="/reset-password"
                           element={<ResetPassword />}
                        />

                        {/* Protected routes */}
                        <Route
                           path="/carrito"
                           element={
                              <ProtectedRoute>
                                 <Carrito />
                              </ProtectedRoute>
                           }
                        />

                        <Route path="/" element={<Inicio />} />
                        <Route path="/contacto" element={<Contacto />} />
                        <Route path="/obras" element={<Obras />} />
                        <Route path="/obrasdet" element={<Obrasdet />} />
                        <Route path="/carritomobile" element={<CarritoMB />} />
                        <Route path="/cotizacion" element={<Cotizacion />} />
                        <Route path="/mispedidos" element={<Mispedidos />} />
                        <Route path="/muestras" element={<Muestras />} />

                        {/* Devolucion de Mercado Pago*/}
                        <Route path="/success" element={<Success />} />
                        <Route path="/failure" element={<Failure />} />
                        <Route path="/pending" element={<Pending />} />

                        {/* Rutas de administración protegidas */}
                        <Route path="/admcuru" element={<Administracion />}>
                           <Route
                              path="contactoadm"
                              element={<ContactoAdm />}
                           />
                           <Route path="tablas" element={<Tablas />} />
                           <Route path="obrasadm" element={<ObrasAdmin />} />
                           <Route path="obrashelp" element={<ObrasHelp />} />
                           <Route path="muestrasadm" element={<MuestrasAdmin />} />
                           <Route path="pedidos" element={<Pedidos />} />
                           <Route path="imagenes" element={<Imagenes />} />
                           <Route path="muestraimagenes" element={<MuestraImagenes />} />
                           <Route path="usuarios" element={<Usuarios />} />
                           <Route path="estadistica" element={<Estadistica />} />
                           <Route
                              path="cotizacionadmin"
                              element={<CotizacionesAdmin />}
                           />
                           <Route
                              path="administradores"
                              element={<Administradores />}
                           />
                        </Route>
                     </Routes>
                  </main>
                  <AcceptCookies />
                  <footer className="bg-gray-800 text-white text-center p-4">
                     © {new Date().getFullYear()} RDM Web Designer
                  </footer>
               </div>
         </Router>
      </AuthProvider>
   );
}

export default App;
